import { API_CONFIG } from '../../shared/api/config';
import composeRequest from '../../shared/api/core';

const BASE_URL = API_CONFIG.API_BASE_PATH;

export const API_URLS = {
    workflowDefinitionsUrl: BASE_URL + 'core/workflows/definitions/',
    workflowStepConfigsUrl: BASE_URL + 'core/workflows/step-configs/',
    notificationEventTypesUrl: BASE_URL + 'core/workflows/notification-event-types/',
    notificationChannelsUrl: BASE_URL + 'core/workflows/notification-channels/',
};

export const getWorkflowDefinitions = (workflowType?: string) => {
    let URL = API_URLS.workflowDefinitionsUrl;
    if (workflowType) {
        URL += `?workflow_type=${encodeURIComponent(workflowType)}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getWorkflowStepConfigs = (businessId: number | string, workflowType?: string) => {
    let URL = `${API_URLS.workflowStepConfigsUrl}?business_id=${businessId}`;
    if (workflowType) {
        URL += `&workflow_type=${encodeURIComponent(workflowType)}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const createWorkflowStepConfig = (payload: any) => {
    return composeRequest(API_URLS.workflowStepConfigsUrl, 'POST', JSON.stringify(payload));
};

export const updateWorkflowStepConfig = (id: number | string, payload: any) => {
    const URL = `${API_URLS.workflowStepConfigsUrl}${id}/`;
    return composeRequest(URL, 'PUT', JSON.stringify(payload));
};

export const deleteWorkflowStepConfig = (id: number | string) => {
    const URL = `${API_URLS.workflowStepConfigsUrl}${id}/`;
    return composeRequest(URL, 'DELETE', null);
};

export const getNotificationEventTypes = (businessId: number | string, eventType?: string) => {
    let URL = `${API_URLS.notificationEventTypesUrl}?business_id=${businessId}`;
    if (eventType) {
        URL += `&event_type=${encodeURIComponent(eventType)}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const createNotificationEventType = (payload: any) => {
    return composeRequest(API_URLS.notificationEventTypesUrl, 'POST', JSON.stringify(payload));
};

export const getNotificationChannels = (businessId: number | string, eventType?: string) => {
    let URL = `${API_URLS.notificationChannelsUrl}?business_id=${businessId}`;
    if (eventType) {
        URL += `&event_type=${encodeURIComponent(eventType)}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const createNotificationChannel = (payload: any) => {
    return composeRequest(API_URLS.notificationChannelsUrl, 'POST', JSON.stringify(payload));
};

export const updateNotificationChannel = (id: number | string, payload: any) => {
    const URL = `${API_URLS.notificationChannelsUrl}${id}/`;
    return composeRequest(URL, 'PUT', JSON.stringify(payload));
};

export const deleteNotificationChannel = (id: number | string) => {
    const URL = `${API_URLS.notificationChannelsUrl}${id}/`;
    return composeRequest(URL, 'DELETE', null);
};
